/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlay: {
  name: 'play';
  data: string;
} = {
  name: 'play',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 8c0-1.648 1.882-2.589 3.2-1.6l5.333 4a2 2 0 0 1 0 3.2l-5.333 4c-1.318.989-3.2.048-3.2-1.6V8Zm7.333 4L9 8v8l5.333-4Z" fill="currentColor"/></svg>`,
};
